import { Logger } from '@sitecore-search/common';
import ChoiceChangedActionHandler from './ChoiceChangedActionHandler.js';
import RangeFacetChangedActionHandler from './RangeFacetChangedActionHandler.js';
const choiceChangedActionHandler = new ChoiceChangedActionHandler();
const actionHandlers = {
    range: new RangeFacetChangedActionHandler(),
    valueId: choiceChangedActionHandler,
    text: choiceChangedActionHandler,
};
function handleFacetChangedAction(query, payload) {
    const { type, rfkId } = payload;
    const currentActionHandler = actionHandlers[type];
    if (currentActionHandler) {
        currentActionHandler.process(rfkId, query, payload);
    }
    else {
        Logger.warn(`${type} has not a valid action handler`);
    }
}
export default handleFacetChangedAction;
